import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'react-error-boundary';
import { KpiDelta } from '../../components/molecules/KpiTile';
import { verdictValueShape } from '../../watchlist/propShapes';
import { buildVerdictDelta, formatVerdictValue } from '../../watchlist/verdictFormat';
import css from './AlertMetrics.css';

const MetricList = ({ items }) => (
    <div className={css.metrics}>
        {items.map((item, index) => {
            const delta = buildVerdictDelta(item.delta, item.tone);
            return (
                // The agent may emit two metrics with the same label and no field.
                // eslint-disable-next-line react/no-array-index-key
                <div className={css.metric} key={`${item.field ?? ''}-${item.label}-${index}`}>
                    <div className={css.metricLabel}>{item.label}</div>
                    <div className={css.metricValue}>{formatVerdictValue(item.value, item.display_format)}</div>
                    {delta && <KpiDelta delta={delta} />}
                </div>
            );
        })}
    </div>
);

MetricList.propTypes = {
    items: PropTypes.arrayOf(verdictValueShape).isRequired,
};

// Views are produced by the agent, so a malformed payload must not take the card down
// with it.
const AlertMetrics = ({ items }) => (
    <ErrorBoundary fallback={null}>
        <MetricList items={items} />
    </ErrorBoundary>
);

AlertMetrics.propTypes = {
    items: PropTypes.arrayOf(verdictValueShape).isRequired,
};

export default AlertMetrics;
